import React from "react";
import { Header, Icon, Container, Button } from "semantic-ui-react";
import { cleanRegister } from "../../../../app/store/actions/registerActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const actions = {
  cleanRegister,
};

const RegisterCompleted = ({ cleanRegister }) => {
  return (
    <Container textAlign="center">
      <br />
      <br />
      <Icon name="check circle outline" color="yellow" size="huge" />
      <Header as="h1" color="blue" size="huge">
        ¡Felicitaciones!
      </Header>
      <Header as="h4" color="blue" size="tiny">
        Tu usuario y contraseña fueron creados satisfactoriamente{" "}
      </Header>
      <br />
      <br />
      <br />
      <Button
        onClick={() => (window.location = "/login")}
        color="yellow"
        size="large"
        content="Iniciar Sesión"
      />
      <Container></Container>
    </Container>
  );
};
RegisterCompleted.propTypes = {
  cleanRegister: PropTypes.func.isRequired,
};
export default connect(null, actions)(RegisterCompleted);
